import type { FlexTheme } from './light'
import commonVars from './_common'

const flexDark: FlexTheme = {
  name: 'Flex',
  self() {
    return commonVars
  }
}

export default flexDark
